<template>
  <div>
    <div class="exam-banner">
      <div class="exam-banner-head">
        <button class="exam-banner-close" @click="$emit('close')" title="Fermer">✕</button>
        <h1 class="exam-banner-title">H à pgmer</h1>
      </div>
    </div>

    <div class="headerSplit">
        <select name="" id="" v-model="mode" @change="getStudentsByMode">
            <option value="null">Exam</option>
            <option value="prog">Programmé</option>
            <option value="wait">En attente</option>
            <option value="vide">Vide</option>
        </select>

        <SimpleTypeahead
            id="typeahead_id"
            placeholder="Rechercher un élève..."
            :items="leleves"
            :minInputLength="1"
            :itemProjection="
            (item) => {
                return item.fullname;
            }
            "
            @selectItem="selectItem"
            @onInput="searchEleve"
            
        >
        </SimpleTypeahead>
    </div>

    <div>
        <button class=" btn-primary" v-if="showBtn" @click="cancelChoice">X</button>
    </div>

    <DataTable :value="students" tableStyle="width: 100%" :rows="10" @click="onSelected" selectionMode="single" v-model:selection="selectedEleve">
        <Column header="Eleve">
          <template #body="slotProps">
            <span :title="slotProps.data.fullnameComplet">{{ slotProps.data.fullname }}</span>
          </template>
        </Column>
        <Column field="heureAPgmer" header="H à pgmer"></Column>
        <Column field="solde" header="Solde"></Column>
        <Column field="exam" header="Exam"></Column>
        <Column field="lieu" header="Lieux"></Column>
    </DataTable>
    <Paginator
        :rows="10"
        :totalRecords="countStudents"
        @page="onPaginate"
    ></Paginator>

  </div>
</template>

<script>

//import moment from "moment";
import SimpleTypeahead from "vue3-simple-typeahead";


export default {

  props: [
    "putSelectEleve",
  ],

  emits: ["close", "putSelectEleve", "changeDisplayApointment"],

  components: {
    SimpleTypeahead,
  },

  data() {
    return {
        mode : "null",
        countStudents : 0,
        students : [],
        eleve : null,
        leleves : [],
        showBtn : false,
        selectedEleve : null,
    };
  },

  mounted() {
    this.getStudentHeureProg(0, "null");
  },

  methods: {

    onSelected(){
        this.$emit("putSelectEleve", this.selectedEleve);
        this.$store.commit('setShowSearchEleve', true);
        this.$store.commit('setPlanningSelectChoice', 'RESA');
        this.$store.commit('setModeResa', 'RESA ELEVE');
        this.$emit("changeDisplayApointment", true);
    },

    selectItem(e){
      window.api
        .get("/eleve/heuresprog/" + e.id + "/" + this.mode, {
          headers: {
            Authorization: "Bearer " + this.$store.state.token,
          },
        })
        .then((response) => {
          this.students = response.data.eleves;
          this.showBtn = true;
        })
        .catch((error) => {
          console.log(error);
        });
    },  

    searchEleve(e){
      if(e.input.length == 3 || e.input.length == 6 || e.input.length == 9 || e.input.length == 12 || e.input.length == 15 || e.input.length == 18 || e.input.length == 21){
          window.api
          .get("/eleves/agence/planning/search/"+this.$store.state.user.agence.id+"/"+e.input, {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          })
          .then((response) => {
            this.leleves = response.data.eleves;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },

    cancelChoice(){
      this.eleve = "";
      this.showBtn = false;
      this.getStudentHeureProg(0, "null");
    },


    getStudentHeureProg(offset, mode){
      window.api
        .get(
          "/eleves/heureaprog/" +
            this.$store.state.user.agence.id +
            "/" +
            offset + 
            "/" +
            mode,
          {
            headers: {
              Authorization: "Bearer " + this.$store.state.token,
            },
          }
        )
        .then((response) => {
            this.students = response.data.eleves;
            this.countStudents = response.data.count;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    onPaginate(e) {
        let offset = e.first;
        this.getStudentHeureProg(offset, this.mode);
    },

    getStudentsByMode(){
        this.getStudentHeureProg(0, this.mode);
    }
  },



};
</script>

<style scoped>

    div.headerSplit{
        display: flex;
        justify-content: space-around;
    }

    div.headerSplit select{
      padding: 9px 12px;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      font-family: inherit;
      font-size: 13px;
      background: #fff;
      color: #1a1f2e;
      outline: none;
      margin-right: 1rem;
      margin-bottom: 1rem;
    }

    :deep(#typeahead_id_wrapper) {
      width: 80%;
    }

    :deep(#typeahead_id) {
      border: 1px solid #e2e8f0;
      border-radius: 16px;
      padding: 10px;
      width: 100%;
    }

    .simple-typeahead :deep(.simple-typeahead-list) {
      position: absolute;
      z-index: 9999;

      background-color: #fff;
      border: 1px solid #ddd;
      border-radius: 4px;
      box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
      max-height: 300px;
      overflow-y: auto;
      margin: 0;
      padding: 0;
      list-style: none;
      width: 40%;
    }

    .simple-typeahead :deep(.simple-typeahead-list-item) {
      padding: 8px 12px;
      cursor: pointer;
      font-size: 14px;
    }

    .simple-typeahead :deep(.simple-typeahead-list-item:hover),
    .simple-typeahead
      :deep(.simple-typeahead-list-item.simple-typeahead-list-item-active) {
      background-color: #f0f4ff;
    }

/* ── Bannière (style aligné sur les mails) ── */
.exam-banner {
  border-radius: 8px;
  overflow: hidden;
  margin: 20px 20px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}

.exam-banner-head {
  position: relative;
  background-color: #1a73e8;
  padding: 20px 24px;
  text-align: center;
}

.exam-banner-close {
  position: absolute;
  top: 12px;
  right: 12px;
  width: 28px;
  height: 28px;
  border: none;
  border-radius: 6px;
  background: #ef4444;
  color: #fff;
  font-size: 13px;
  line-height: 1;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-banner-close:hover {
  background: #dc2626;
}

.exam-banner-title {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
  letter-spacing: 0.3px;
  color: #ffffff;
}

</style>
